import './Plans.scss'
import {useQuery} from "@tanstack/react-query";
import {getPlansApi} from "../../api/statusApi";
import {SEC} from "../../util/time-and-date";
import dayjs from "dayjs";
import {numberFormat} from "../../util/numbers";
import {useDispatch, useSelector} from "react-redux";
import {TRANSACTION_TYPES} from "../../../../back-end/constants/transactions.js";
import {assetTypeToGroup, getSpecificAsset} from "../../ducks/assets-duck.js";
import {
    setAssetId,
    setCost,
    setIsCompanyTransaction,
    setTransactionDate,
    setType
} from "../../ducks/add-transaction-duck.js";
import {useNavigation} from "../util/navigation/navigation.js";
import {APP_ROUTES} from "../../App.jsx";
import InternalLink from "../util/navigation/InternalLink.jsx";
import ArrowRightIcon from "mdi-react/ArrowRightIcon.js";
import AssetListIcon from "../util/icons/AssetListIcon.jsx";

export default () => {

    const {data = {}} = useQuery({
        queryKey: ['plans-api'],
        queryFn: getPlansApi,
        refetchInterval: 10 * SEC,
    })

    const {missingTransactions = []} = data

    return missingTransactions.length > 0 && (
        <div className='plans'>
            <ul>
                {missingTransactions.map(tx => <MissingTransaction key={`${tx.asset_id}-${tx.date}`} {...tx} />)}
            </ul>
            <InternalLink
                to={APP_ROUTES.transactionsAddBulk}
                className='bulk-import-link'
                icon={<ArrowRightIcon/>}
            >
                Go to bulk import
            </InternalLink>
        </div>
    )
}

const MissingTransaction = ({date, asset_id, asset_name, amount, is_company}) => {
    const dispatch = useDispatch()
    const {navigateTo} = useNavigation()
    const {asset_type: assetType = ''} = useSelector(state => getSpecificAsset(state, asset_id))
    const dateFormatted = dayjs(date).format('YYYY-MM-DD')
    const onClick = () => {
        dispatch(setType(TRANSACTION_TYPES.BUY))
        dispatch(setAssetId(asset_id))
        dispatch(setTransactionDate(dateFormatted))
        dispatch(setCost(amount))
        dispatch(setIsCompanyTransaction(!!is_company))
        navigateTo(`${APP_ROUTES.transactionsAdd}?skipTo=2`)
    }
    return (
        <li>
            <button onClick={onClick}>
                <AssetListIcon name={asset_name} assetGroup={assetTypeToGroup(assetType)}/>
                <div className='details'>
                    <div className='flex-vertical-center'>
                        <div className='amount'>
                            <span className='prefix'>kr </span>
                            {numberFormat(amount, 0)}
                        </div>
                        <div className='date'>
                            {dateFormatted}
                        </div>
                    </div>
                    <div className='asset-name'>
                        {asset_name}
                    </div>
                </div>
            </button>
        </li>
    )
}